import Icon from '../templates/creatives/Icon';

const CreativeIconDirective = reactDirective => {
  return reactDirective(Icon, undefined, { restrict: 'E' });
};

CreativeIconDirective.$inject = ['reactDirective'];

export default CreativeIconDirective;
